import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import CourseCompletionService from './CourseCompletionService';

const CertificateVerify = () => {
  const { id } = useParams();
  const [rollNumber, setRollNumber] = useState('');
  const [error, setError]           = useState('');
  const [loading, setLoading]       = useState(false);
  const [pdfUrl, setPdfUrl]         = useState(null);

  const handleVerify = async (e) => {
    e.preventDefault();
    if (!rollNumber.trim()) {
      setError('Please enter your Roll Number.');
      return;
    }
    setLoading(true);
    setError('');

    try {
      const { status, data } = await CourseCompletionService.verifyCertificate( id, rollNumber, '');
      if (status === 200) {
        const blob = new Blob([data], { type: 'application/pdf' });
        setPdfUrl(window.URL.createObjectURL(blob));
      } else {
        const text = await new Response(data).text();
        let msg = 'Invalid roll number. Please check and try again.';
        try { msg = JSON.parse(text).error || msg; } catch (_) {}
        setError(msg);
      }
    } catch (err) {
      setError('Something went wrong. Please try again.');
    }

    setLoading(false);
  };

  if (pdfUrl) {
    return (
      <div className="flex coldir ht-100vh">
        <div className="flex justspacebetween aligncenter bg-black p-10">
          <span className="white fw500 f16">Your Certificate</span>
          <a href={pdfUrl} download="certificate.pdf"
            className="bg-green white brd-5 p-5-10 fw500 f14"> <i className="fas fa-download m-r-5" />
            Download
          </a>
        </div>
        <iframe
          src={pdfUrl}
          className="flex-1 no-border w-100p"
          title="Certificate Preview"
        />
      </div>
    );
  }

  return (
    <div className="flex aligncenter justifycenter bg-grey-1 mih-100vh p-20">
      <div className="bg-white brd-10 shadow-small p-20 w-100p mxw-420">
        <div className="text-center m-b-20">
          <i className="fas fa-certificate f40 text-green" />
          <h2 className="fw700 f18 m-t-10 m-b-5">View Your Certificate</h2>
          <p className="text-gray font-14 m0">
            Enter your roll number to verify and access your certificate
          </p>
        </div>

        <form onSubmit={handleVerify}>
          <div className="m-b-20">
            <label className="fw500 font-14 m-b-5 d-block">Roll Number</label>
            <input
              value={rollNumber}
              onChange={(e) => { setRollNumber(e.target.value); setError(''); }}
              placeholder="Enter your roll number"
              className="form-control form-input-gray w-100p p-10"/>
          </div>

          {error && (
            <div className="bg-lred-2 brd-5 p-10 m-b-15 font-14 flex aligncenter gap-5">
              <i className="fas fa-exclamation-circle lred m-r-5" />
              <span className="lred">{error}</span>
            </div>
          )}

          <button
            type="submit" disabled={loading}
            className={`bg-green white w-100p brd-5 fw700 f16 p-10 no-border ${loading ? 'op-70 cur-not-allowed' : 'pointer'}`}>
            {loading
              ? <><i className="fas fa-spinner fa-spin m-r-5" />Verifying...</>
              : <><i className="fas fa-unlock-alt m-r-5" />View Certificate</>
            }
          </button>

        </form>
      </div>
    </div>
  );
};

export default CertificateVerify;